module.exports = __webpack_public_path__ + "static/media/thank.d8ac0aa3.gif";